let main = $("main");
let postid = main.data("postid");
let pagebaseurl = main.data("url");
let netrating = $(".stars").data("ratingval");
let rndnum = Math.floor(Math.random() * 1000000);
new WOW().init();
$("#ratingPost .stars i:nth-child(1)")
  .on("mouseover", function () {
    $("#ratingPost .stars i:nth-child(1)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
  })
  .on("mouseout", function () {
    switch (netrating) {
      case 1:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 1.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693").addClass("fa-star-half-full");
        break;
      case 5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693");
        break;
      default:
        $("#ratingPost .stars i:nth-child(1)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
    }
  })
  .click(function () {
    $("#ratingPost .stars i").hide();
    $("#ratingPost .stars > div").hide();
    $("#ratingPost .stars").append('<i class="fa fa-circle-o-notch fa-spin" style="font-size:25px;color:#4f9399;"></i>');
    $("#ratingPost").load(pagebaseurl + "ajax/rating.php?postid=" + postid + "&ratingval=1&rndnum=" + rndnum);
  });
$("#ratingPost .stars i:nth-child(2)")
  .on("mouseover", function () {
    $("#ratingPost .stars i:nth-child(1)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(2)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
  })
  .on("mouseout", function () {
    switch (netrating) {
      case 1:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 1.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693").addClass("fa-star-half-full");
        break;
      case 5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693");
        break;
      default:
        $("#ratingPost .stars i:nth-child(1)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
    }
  })
  .click(function () {
    $("#ratingPost .stars i").hide();
    $("#ratingPost .stars > div").hide();
    $("#ratingPost .stars").append('<i class="fa fa-circle-o-notch fa-spin" style="font-size:25px;color:#4f9399;"></i>');
    $("#ratingPost").load(pagebaseurl + "ajax/rating.php?postid=" + postid + "&ratingval=2&rndnum=" + rndnum);
  });
$("#ratingPost .stars i:nth-child(3)")
  .on("mouseover", function () {
    $("#ratingPost .stars i:nth-child(1)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(2)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(3)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
  })
  .on("mouseout", function () {
    switch (netrating) {
      case 1:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 1.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693").addClass("fa-star-half-full");
        break;
      case 5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693");
        break;
      default:
        $("#ratingPost .stars i:nth-child(1)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
    }
  })
  .click(function () {
    $("#ratingPost .stars i").hide();
    $("#ratingPost .stars > div").hide();
    $("#ratingPost .stars").append('<i class="fa fa-circle-o-notch fa-spin" style="font-size:25px;color:#4f9399;"></i>');
    $("#ratingPost").load(pagebaseurl + "ajax/rating.php?postid=" + postid + "&ratingval=3&rndnum=" + rndnum);
  });
$("#ratingPost .stars i:nth-child(4)")
  .on("mouseover", function () {
    $("#ratingPost .stars i:nth-child(1)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(2)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(3)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(4)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
  })
  .on("mouseout", function () {
    switch (netrating) {
      case 1:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 1.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693").addClass("fa-star-half-full");
        break;
      case 5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693");
        break;
      default:
        $("#ratingPost .stars i:nth-child(1)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
    }
  })
  .click(function () {
    $("#ratingPost .stars i").hide();
    $("#ratingPost .stars > div").hide();
    $("#ratingPost .stars").append('<i class="fa fa-circle-o-notch fa-spin" style="font-size:25px;color:#4f9399;"></i>');
    $("#ratingPost").load(pagebaseurl + "ajax/rating.php?postid=" + postid + "&ratingval=4&rndnum=" + rndnum);
  });
$("#ratingPost .stars i:nth-child(5)")
  .on("mouseover", function () {
    $("#ratingPost .stars i:nth-child(1)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(2)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(3)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(4)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
    $("#ratingPost .stars i:nth-child(5)").css("color", "#ff1f4a").removeClass("fa-star-o").removeClass("fa-star-half-full").addClass("fa-star");
  })
  .on("mouseout", function () {
    switch (netrating) {
      case 1:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 1.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 2.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 3.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693").addClass("fa-star-half-full");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
      case 4.5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693").addClass("fa-star-half-full");
        break;
      case 5:
        $("#ratingPost .stars i:nth-child(1)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(2)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(3)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(4)").css("color", "#f78693");
        $("#ratingPost .stars i:nth-child(5)").css("color", "#f78693");
        break;
      default:
        $("#ratingPost .stars i:nth-child(1)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(2)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(3)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(4)").css("color", "lightgray").addClass("fa-star-o");
        $("#ratingPost .stars i:nth-child(5)").css("color", "lightgray").addClass("fa-star-o");
        break;
    }
  })
  .click(function () {
    $("#ratingPost .stars i").hide();
    $("#ratingPost .stars > div").hide();
    $("#ratingPost .stars").append('<i class="fa fa-circle-o-notch fa-spin" style="font-size:25px;color:#4f9399;"></i>');
    $("#ratingPost").load(pagebaseurl + "ajax/rating.php?postid=" + postid + "&ratingval=5&rndnum=" + rndnum);
  });
